import actions from '@/core/store/pedido/actions'
import getters from '@/core/store/pedido/getters'
import mutations from '@/core/store/pedido/mutations'
import state from '@/core/store/pedido/state'
import documentoPedido from '@/core/store/pedido/documentos'
import dotacaoOrcamentaria from './dotacao-orcamentaria'
import revisoes from './revisoes'

export default {
	actions,
	getters,
	mutations,
	state,
	modules: {
		documentoPedido,
		dotacaoOrcamentaria,
		revisoes,
	},
}
